import { isProd, isTestnet } from '@bfe/by-env';
import { useEffect, useState } from 'react';

import { tgBindNotBotName } from '@/utils/trace-list/tgBind';

import { tgBindCallback } from '../utils/trace-list/setting';

const TelegramBotNames = {
  test: 'wao_l_bot',
  'testnet.bybit.com': 'Bybit_Testnet01_bot',
  'www.cht-test-6.bybit.com': 'wao_l_bot',
  'www.unify-test-3.bybit.com': 'unifyTest3Bot',
  'www.unify-test-1.bybit.com': 'BybitDevBot',
  'www.unify-test-1.bybit.nl': 'bybit_nl_bot',
  'www.unify-test-1.bybit.ae': 'bybit_ae_bot',
  'www.bybit.com': 'Bybit_Mainnet01_bot',
  'www.bybit-global.com': 'Bybit_Mainnet02_bot',
  'www.bybit.biz': 'Bybit_Mainnet03_bot',
  'www.bybit.cloud': 'Bybit_Mainnet04_bot',
  'www.bybit.global': 'Bybit_Mainnet05_bot',
  'www.bybit.org': 'Bybit_Mainnet06_bot',
  'www.bybitgum.com': 'Bybit_Mainnet07_bot',
  'www.bybitgum.org': 'Bybit_Mainnet08_bot',
  'www.bybits.io': 'Bybit_Mainnet09_bot',
  'www.bycloud.org': 'Bybit_Mainnet10_bot',
  'www.bybit-test-1.bybit.com': 'bybittest1Bot',
  'www.bybits.org': 'Bybit_Mainnet11_bot',
  'www.bybitx.global': 'Bybit_Mainnet12_bot',
  'www.bybitglobal.com': 'Bybit_Mainnet13_bot',
  'www.bytick.com': 'Bybit_Mainnet14_bot',
  'testnet.bybit.ae': 'Bybit_Testnet_AE_bot',
  'www.bybit.ae': 'Bybit_Mainnet_AE_bot',
  'testnet.bybit.nl': 'Bybit_Testnet_NL_bot',
  'www.bybit.nl': 'Bybit_Mainnet_NL_bot',
  'testnet.bybit.global': 'Bybit_Testnet02_bot',
  'testnet.bybitgum.com': 'Bybit_Testnet03_bot',
  'testnet.bybit-global.com': 'Bybit_Testnet04_bot',
  'testnet.bybitgum.org': 'Bybit_Testnet05_bot',
  'testnet.bybitx.global': 'Bybit_Testnet06_bot',
  'www.unify-test-1.bybit-ge.com': 'unify_test_1_ge_bot',
  'testnet.bybit-ge.com': 'Bybit_Testnet_GE_bot',
  'www.bybit-ge.com': 'Bybit_Mainnet_GE_bot',
  'www.bybit.id': 'Bybit_Mainnet_ID_bot',
  'testnet.bybit.id': 'Bybit_Testnet_ID_bot',
  'www.unify-test-1.bybit.id': 'unify_test_1_ide_bot',
  'www.unify-test-1.bybitgeorgia.ge': 'unify_test_1_ge_bot',
  'testnet.bybitgeorgia.ge': 'Bybit_Testnet_GE_bot',
  'www.bybitgeorgia.ge': 'Bybit_Mainnet_GE_bot',
};
let time = 10;
const loadTgWidget = (botName: string, authRedirectUrl = '') => {
  const script = document.createElement('script');
  script.src = 'https://telegram.org/js/telegram-widget.js?22';
  script.setAttribute('data-size', 'large');
  script.setAttribute('data-request-access', 'write');
  script.setAttribute('data-telegram-login', botName);
  script.setAttribute('data-userpic', 'false');
  if (authRedirectUrl) {
    script.setAttribute('data-auth-url', authRedirectUrl);
  } else {
    script.setAttribute('data-onauth', 'bindTgCallback(user)');
  }
  const container = document.getElementById('widget-container');
  if (container) {
    container.appendChild(script);
  } else {
    if (time <= 0) {
      return;
    }
    time -= 1;
    setTimeout(() => {
      loadTgWidget(botName, authRedirectUrl);
    }, 50);
  }
};

const useTgBind = ({
  tgCallback,
  authRedirectUrl = '',
}: {
  tgCallback?: (params: any) => void;
  authRedirectUrl?: string;
}) => {
  const [botName, setBotName] = useState('');

  useEffect(() => {
    const clearHash = () => {
      const hash = window.location.hash;
      if (hash.indexOf('tgAuthResult')) {
        window.location.hash = '';
      }
    };
    if (sessionStorage.getItem('CLEAR_TG_AUTH_RESULT') !== 'true') {
      clearHash();
      sessionStorage.setItem('CLEAR_TG_AUTH_RESULT', 'true');
    }
  }, []);

  useEffect(() => {
    window.bindTgCallback = (params: any = {}) => {
      const newParams: any = params;
      Object.keys(params).forEach((key) => {
        newParams[key] = `${params[key]}`;
      });
      tgCallback?.(newParams);
      tgBindCallback(newParams);
    };
    const hostname = window.location.hostname as keyof typeof TelegramBotNames;
    const botName =
      TelegramBotNames[hostname] ||
      (!isTestnet && !isProd ? TelegramBotNames['test'] : '');
    setBotName(botName);
    if (botName) {
      loadTgWidget(botName, authRedirectUrl);
    } else {
      tgBindNotBotName();
    }
  }, []);

  return {
    botName,
  };
};

export default useTgBind;
